import BasicList from '../BasicList';
import {get} from '../../utils/fetch';
import { backendServer } from '../../variable';

const requestList = async ({page, pageSize, ...params}) => {
  try {
    const result = await get(`${backendServer}/agentBuyBackOperating/queryBuyBackRecord`, {
      page,
      pageSize,
      ...params
    });
    return result;
  } catch (e) {
    throw e;
  }
};

// 回购记录列表
const repurchaseList = new BasicList(requestList);
repurchaseList.setListName('回购记录');

export default repurchaseList;



// WEBPACK FOOTER //
// ./src/stores/RepurchaseList/index.js